import React from "react";
import { Link } from "react-router-dom";
import { BsFilePersonFill } from "react-icons/bs";
import BarData from "./BarData";
import "./Bar.css";

function Bar() {

  const menus = [
    { name: "home", path: "/DayList" },
    { name: "calendar", path: "/Month" },
    { name: "profile", path: "/Profile" }
  ];

  return (
    <div className="Nav">

      {menus.map((menu, index) => {
        return (
          <Link to={menu.path} key={index}>
            <BarData
              menu={menu}
            />
          </Link>
        );
      })}
    </div>
  );
}

export default Bar;